<template>
	<ul class="tab_list">
		<li
			:key="`tab-${key}`"
			v-for="(item, key) in tab"
			:class="[item.className, { on: key === currentTab }]"
			@click.stop="$emit('click', key)"
		>
			{{ item.name }}
		</li>
	</ul>
</template>

<script>
export default {
	name: "TabArea",
	props: {
		tab: {
			type: Array,
			required: true,
		},
		currentTab: {
			type: Number,
			default: 0,
		},
	},
};
</script>
